"use client";

import { useAdsConversionTracker } from "./useAdsConversionTracker";

export function AdsConversionTracker() {
  useAdsConversionTracker();
  return null;
}
